<!-- //中间栏模块 -->
<template>
  <div class="leftContainer" :class="{ collapsedLeft: store.state.user.isLeftCollapsed }"
    style="box-sizing: border-box;">
    <div class="title">
      <div class="title_util">
        <!-- <el-input
          v-model="input2"
          placeholder="Type something"
          :prefix-icon="Search"
        /> -->
        <!-- <el-icon :size="20">
        <Search />
      </el-icon> -->

        <el-input v-model="searchKeyWords" size="small" style="padding:0;" placeholder="搜索账号">
          <template #prefix>
            <i class="iconfont icon-search"></i>
          </template>
        </el-input>
        <!-- <span @click="haldleSetLeftCollapsedToggled" :class="{collapsedLeftIcon:store.state.user.isLeftCollapsed,uncollapsedLeft:!store.state.user.isLeftCollapsed}">
          <i class="iconfont icon-shousuo"></i>
        </span> -->
      </div>
    </div>
    <!-- <div class="title_tip">
      账号数{{ accountList.length }},已加载账号数:{{ 100 }}
    </div> -->

    <v3-scroll autohide zIndex="2021">
      <div class="item_contaimer">
        <div>
          <el-alert type="info" v-if="!accountList || accountList?.length == 0">
            <div style="font-size: 12px;">账号未显示
              <el-tooltip class="box-item" effect="light" placement="top-start">
                <template #content>
                  <p>常见问题：</p>
                  <ul>
                    <li class="m_desc">1. 您新分配的账号需要<em class="m_color_p">收到第一条新信息</em>后才会显示哦!</li>
                  </ul>
                </template>
                <i class="iconfont icon-tishi1"></i>
              </el-tooltip>
            </div>
          </el-alert>
        </div>
        <div class="item" v-for="(item, index) in accountList" :key="index" @click="handleSelectAccouont(item)"
          :class="{ selectAccount: item.id === selectedAccountId }"
          @contextmenu.prevent="handleContextMenu($event, item, true)">
          <douyinaccount v-if="chatingPlatId == 1" @showAccountInfo="handleShowUinfoLayer"
            @changeAiStatus="handleUseRobotStatusChange" :item="item"></douyinaccount>
          <xiaohsaccount v-else-if="chatingPlatId == 2" @showAccountInfo="handleShowUinfoLayer"
            @changeAiStatus="handleUseRobotStatusChange" :item="item"></xiaohsaccount>
          <webh5account v-else-if="chatingPlatId == 3" @showAccountInfo="handleShowUinfoLayer"
            @changeAiStatus="handleUseRobotStatusChange" :item="item"></webh5account>
          <wechataccount v-else-if="chatingPlatId == 4" @showAccountInfo="handleShowUinfoLayer"
            @changeAiStatus="handleUseRobotStatusChange" :item="item"></wechataccount>
          <kuaishouaccount v-else-if="chatingPlatId == 5" @showAccountInfo="handleShowUinfoLayer"
            @changeAiStatus="handleUseRobotStatusChange" :item="item"></kuaishouaccount>
          <laikeimaccount v-else-if="chatingPlatId == 10" @showAccountInfo="handleShowUinfoLayer"
            @changeAiStatus="handleUseRobotStatusChange" :item="item"></laikeimaccount>
          <!-- <div class="selectFlag" v-if="item.id === selectedAccountId">

            </div> -->
          <div v-if="muteAccountIds.includes(item.id)"><i class="iconfont icon-jingyin m_color_e1"></i></div>
        </div>

      </div>
    </v3-scroll>
    <!-- 卡片模板 -->
    <v3-layer v-model="isShowUinfoLayer" :follow="uInfoLayerPos" opacity="0" teleport="body" :zIndex="999">
      <div class="rlay__uCards">
        <div class="item flexbox flex-alignc vui__hairline-bottom">
          <span class="lbl flex1"><em class="fs-18">{{ mainData.selectAccountInfoRow.username || '--' }}</em><em
              class="iconfont icon-male ml-10 c-46b6ef"></em></span>
          <img class="uimg" :src="mainData.selectAccountInfoRow.avatar || '@assets/img/uimg/img-avatar01.jpg'" />
        </div>
        <div class="item flexbox flex-alignc vui__hairline-bottom">
          <label class="lbl flex1">分类：{{
            $syscfgNameByValue('customer_type_list', mainData.selectAccountInfoRow.customer_type_id) }}</label>
        </div>
      </div>
    </v3-layer>
    <!-- 隐藏的账号列表 -->
    <div style="z-index: 2022;" class="hide_account_c" :class="{ hide_account_c__br: showHideAccountRef }"
      v-if="hideAccountList.length > 0">
      <div class="hide_account_c__header m_color_2" :class="{ hide_account_c__header_br: showHideAccountRef }"
        @click.prevent="handleToggleShowHideAccount">
        隐藏账号（{{ hidAccountIds.length || 0 }}）
        <div class="ml_10" style="cursor: pointer;">
          <span v-if="showHideAccountRef" class="m_color_e1">关闭</span>
          <span v-else>查看</span>
        </div>
      </div>
      <Transition name="fade">
        <div v-if="showHideAccountRef" class="hide_account_c__body">
          <div style="flex:1;height: 1px;">
            <v3-scroll autohide zIndex="2021">
              <div class="item_contaimer">
                <div class="item" v-for="(item, index) in hideAccountList" :key="index"
                  @click="handleSelectAccouont(item)" :class="{ selectAccount: item.id === selectedAccountId }"
                  @contextmenu.prevent="handleContextMenu($event, item, false)">
                  <douyinaccount v-if="chatingPlatId == 1" @showAccountInfo="handleShowUinfoLayer"
                    @changeAiStatus="handleUseRobotStatusChange" :item="item"></douyinaccount>
                  <xiaohsaccount v-else-if="chatingPlatId == 2" @showAccountInfo="handleShowUinfoLayer"
                    @changeAiStatus="handleUseRobotStatusChange" :item="item"></xiaohsaccount>
                  <webh5account v-else-if="chatingPlatId == 3" @showAccountInfo="handleShowUinfoLayer"
                    @changeAiStatus="handleUseRobotStatusChange" :item="item"></webh5account>
                  <wechataccount v-else-if="chatingPlatId == 4" @showAccountInfo="handleShowUinfoLayer"
                    @changeAiStatus="handleUseRobotStatusChange" :item="item"></wechataccount>
                  <kuaishouaccount v-else-if="chatingPlatId == 5" @showAccountInfo="handleShowUinfoLayer"
                    @changeAiStatus="handleUseRobotStatusChange" :item="item"></kuaishouaccount>
                  <laikeimaccount v-else-if="chatingPlatId == 10" @showAccountInfo="handleShowUinfoLayer"
                    @changeAiStatus="handleUseRobotStatusChange" :item="item"></laikeimaccount>
                  <!-- <div class="selectFlag" v-if="item.id === selectedAccountId">

                    </div> -->
                  <div v-if="muteAccountIds.includes(item.id)"><i class="iconfont icon-jingyin m_color_e1"></i></div>
                </div>
              </div>
            </v3-scroll>
          </div>
        </div>
      </Transition>
    </div>
    <!-- END 隐藏的账号列表 -->

    <!-- 右键菜单 -->
    <div v-show="contextMenuVisible" :style="{ top: contextMenuTop + 'px', left: contextMenuLeft + 'px' }"
      class="context-menu">
      <div style="padding-left: 20px;padding-bottom: 5px;margin-bottom: 5px; border-bottom: 1px solid #d9d9d9;">
        操作账号：<span> {{ mentRecordItem.username || "--" }}</span>
      </div>
      <el-menu ref="menuRef" class="main-menu" @select="handleContextMenuSelect" background-color="#dbe2ef"
        active-text-color="#3f72af" text-color="#3f72af">
        <el-menu-item index="1">
          <span v-if="mentRecordItem.isShow">隐藏</span>
          <span v-else>显示</span>
          此账号
        </el-menu-item>
        <el-menu-item index="2">
          (静音/取消静音)此账号
        </el-menu-item>
      </el-menu>
    </div>
  </div>
</template>
<script>
// 引入动态组件（中间栏）
import { reactive, toRefs, computed, inject, onMounted, onUnmounted, ref } from "vue";
import { getAccountFriendList } from "@/api/chatapi";
import { changeAiStatus } from '@/api/aichatapi'
import { useStore } from "vuex";
import douyinaccount from "./douyinaccount.vue";
import webh5account from "./webh5account.vue";
import wechataccount from "./wechataccount.vue";
import kuaishouaccount from "./kuaishouaccount.vue";
import laikeimaccount from "./laikeimaccount.vue";
import xiaohsaccount from "./xiaohsaccount.vue";
import { SELECT_FRIEND_LIMIT } from '@/constants/common-const';
import { addUserHideAccount } from '@/idxdb/chat_db_cache'

export default {
  components: { douyinaccount, webh5account, wechataccount, kuaishouaccount, xiaohsaccount,laikeimaccount },
  setup() {
    const bus = inject("$eventBus");
    const wsCmd = inject("wsCmd");
    const eventbusCms = inject("eventbusCms");
    let store = useStore();

    // --------- 隐藏账号 -----------
    const showHideAccountRef = ref(false)
    const handleToggleShowHideAccount = async () => {
      showHideAccountRef.value = !showHideAccountRef.value
    }


    //右键菜单
    // 菜单显示状态
    const contextMenuVisible = ref(false)
    // 菜单位置
    const contextMenuTop = ref(0)
    const contextMenuLeft = ref(0)
    const menuRef = ref(null) // 菜单的 DOM 引用（关键）
    const mentRecordItem = ref({})

    //isShow 操作来源是显示的列表还是隐藏的列表
    const handleContextMenu = async (e, item, isShow) => {
      e.preventDefault()
      // 获取视口尺寸
      const viewportHeight = window.innerHeight

      let top = e.clientY
      // 计算安全位置（预留 5px 边距）
      const safeMargin = 5
      //元素高度暂时设置100px
      // 获取菜单自身尺寸（需考虑边框和内边距，使用 getBoundingClientRect）
      // const menuRect = menuEl.getBoundingClientRect()
      // const menuWidth = menuRect.width
      // const menuHeight = menuRect.height
      let menuHeight = 100
      // 垂直方向调整：避免超出底部
      if (top + menuHeight > viewportHeight - safeMargin) {
        top = viewportHeight - menuHeight - safeMargin
      }

      contextMenuVisible.value = true
      contextMenuTop.value = top
      contextMenuLeft.value = e.clientX
      mentRecordItem.value = item
      mentRecordItem.value.isShow = isShow
      // 点击其他地方隐藏菜单
      document.addEventListener('click', hideContextMenu)
    }
    // 隐藏右键菜单
    const hideContextMenu = (e) => {
      // 获取点击的目标元素
      const target = e.target

      // 判断目标是否在菜单内部（包括菜单本身及其子元素）
      const isInsideMenu = menuRef.value?.$el?.contains(target)

      // 如果点击的是菜单内部，不隐藏；否则隐藏
      if (!isInsideMenu) {
        contextMenuVisible.value = false
        document.removeEventListener('click', hideContextMenu)
      }
    }
    const handleContextMenuSelect = async (key) => {
      contextMenuVisible.value = false
      document.removeEventListener('click', hideContextMenu)
      let id = mentRecordItem.value.id
      let data = { platId: chatingPlatId.value, id }
      //1 隐藏账号
      if (key == 1) {
        if (mentRecordItem.value.isShow) {
          store.dispatch('chat_store/doAddHideAccountId', data)
        } else {
          store.dispatch('chat_store/doDeleteHideAccountId', data)
        }
      } else if (key == 2) {
        //2 静音操作
        if (muteAccountIds.value.includes(id)) {
          store.dispatch('chat_store/doDeleteMuteAccountId', data)
        } else {
          store.dispatch('chat_store/doAddMuteAccountId', data)
        }
      }
    }
    // --------- END 隐藏账号 -----------


    const data = reactive({
      searchKeyWords: '',
      status: "online",
      isShowUinfoLayer: false,
      uInfoLayerPos: null,
    });
    const mainData = reactive({

      selectAccountInfoRow: {}
    })

    //隐藏的额账号列表
    const hidAccountIds = computed(() => {
      return store.state.chat_store.hidAccountIds
    })
    //静音的账号列表
    const muteAccountIds = computed(() => {
      return store.state.chat_store.muteAccountIds
    })

    //当前选中平台
    const chatingPlatId = computed(() => {
      return store.state.chat_store.chat_plat_id
    });


    //当前选中账号
    const selectedAccountId = computed(() => {
      return store.state.chat_store.user_account_select?.id
    });




    //账号列表
    const accountList = computed(() => {
      let accountList = store.state.chat_store.user_accounts
      // if (accountList && accountList.length > 0) {
      //   //如果没设置选中账号则处理
      //   let chatingAccountId = store.state.chat_store.user_account_select?.id
      //   console.log('~~~~~~~~~~chatingAccountId',chatingAccountId)
      //   if (!chatingAccountId) {
      //     //新缓存------------
      //     store.dispatch('chat_store/doSetUserAccountSelect', accountList[0])
      //     handleSelectAccouont(accountList[0])

      //   }
      // }

      if (!accountList) {
        return []
      }
      return accountList.filter(item => {
        let kfilter = haldleFilterAccount(item, data.searchKeyWords)
        //不再隐藏的账号列表中
        let id = item.id
        let notHide = !hidAccountIds.value.includes(id)
        return kfilter && notHide
      }) || [];
    });

    const hideAccountList = computed(() => {
      let accountList = store.state.chat_store.user_accounts
      return accountList.filter(item => {
        //不再隐藏的账号列表中
        let id = item.id
        let hide = hidAccountIds.value.includes(id)
        return hide
      }) || [];
    })

    //过滤账号
    const haldleFilterAccount = (friendItem, searchKeyWords) => {
      if (searchKeyWords) {
        let _searchKeywords = searchKeyWords.replace(/^\s\s*/, '').replace(/\s\s*$/, '')
        if (_searchKeywords.length == 0) {
          return true
        }
        let title = friendItem.username
        if (!title) {
          return false
        }
        return title.includes(_searchKeywords)
      } else {
        return true
      }
    }



    //左侧边栏收缩
    const haldleSetLeftCollapsedToggled = () => {
      store.commit("user/SET_LEFT_COLLAPSED_TOGGLED");
    }


    // 用户卡片
    const handleShowUinfoLayer = (row) => {

      //如果折叠起来了直接事件冒泡就好了
      if (store.state.user.isLeftCollapsed) {
        return
      }

      // let pos = [e.clientX, e.clientY];
      data.isShowUinfoLayer = true;
      data.uInfoLayerPos = row.pos;
      mainData.selectAccountInfoRow = row.rowItem
    };

    //账号选择(查询首100条)
    function handleSelectAccouont(item) {
      // store.commit("wsData/SET_CHATING_ACCOUNT", item);
      //清理正选择的好友信息
      // store.commit("wsData/CLEAR_CHATING_FRIEND");
      //新缓存------------
      store.dispatch('chat_store/doSetUserAccountSelect', item)

      //获取账号好友列表
      getAccountFriendList({ aid: item.id, limit: SELECT_FRIEND_LIMIT, log_id: 0 },'search')
      return
    }

    //加载账号更多好友
    const handleLoreMoreFriend = (data) => {
      data.limit = SELECT_FRIEND_LIMIT
      getAccountFriendList(data,'search')
    }

    //当前聊天账号
    const chatingAccount = computed(() => {
      return store.state.chat_store.user_account_select
    });

    //切换机器人接管状态
    const handleUseRobotStatusChange = (item) => {
      let data = { aid: item.id, status: item.use_robot_status }
      changeAiStatus(data, item.id)
    }

    const receiveAiStatusResult = (resp) => {
      // console.log('----------------')
      // console.log(resp)
    }

    onMounted(() => {
      //当前选中账号
      //handleSelectAccouont(chatingAccount.value)

      // bus.on(`${wsCmd.cmd_2_resp}`, receiveAccountList); // listen
      // bus.on(`${wsCmd.cmd_21_resp}`, receiveAiStatusResult); // listen
      // //加载更多好友
      // bus.on(eventbusCms.loadMoreAccountFriend, handleLoreMoreFriend); // listen
    });

    onUnmounted(() => {
      // bus.off(`${wsCmd.cmd_2_resp}`); // listen
      // bus.off(`${wsCmd.cmd_21_resp}`); // listen
      // bus.off(eventbusCms.loadMoreAccountFriend); // listen
    })

    return {
      ...toRefs(data),
      handleShowUinfoLayer,
      accountList,
      selectedAccountId,
      mainData,
      store,
      chatingAccount,
      chatingPlatId,
      haldleFilterAccount,
      handleSelectAccouont,
      haldleSetLeftCollapsedToggled,
      handleUseRobotStatusChange,
      //-----显示隐藏账号
      hideAccountList,
      hidAccountIds,
      showHideAccountRef,
      handleToggleShowHideAccount,
      contextMenuTop,
      contextMenuLeft,
      menuRef,
      mentRecordItem,
      handleContextMenu,
      handleContextMenuSelect,
      contextMenuVisible,
      //-----显示隐藏账号
      // ------静音--
      muteAccountIds,
      // END------静音--
    };
  },
};
</script>

<style lang="scss" scoped>
@import url(./accountitem.scss);

.hide_account_c {
  background-color: rgba(24, 24, 24, .9);

  position: absolute;
  bottom: 0;
  width: 100%;
}

.hide_account_c__br {
  border-radius: 15px 15px 0 0;
}


.hide_account_c__header {
  box-sizing: border-box;

  // background-color: rgba(24, 24, 24, 1);
  // background-color: rgba(87, 107, 149, 0.5);
  background-color: rgba(223, 229, 244, .9);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0px 10px 10px 0px rgba(255, 255, 255, 0.2);
  height: 30px;
  cursor: pointer;
}

.hide_account_c__header_br {
  border-radius: 10px 10px 0 0;
}

.hide_account_c__body {
  height: 500px;
  display: flex;
  flex-direction: column;
}

.fade-enter-active,
.fade-leave-active {
  transition: all 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  max-height: 0;
}

.fade-enter-to,
.fade-leave-from {
  opacity: 1;
  max-height: 500px;
  /* 设置为比实际最大高度更大的值 */
}

// -------右键菜单--------
.context-menu {
  position: fixed;
  z-index: 9999;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  min-width: 150px;
  border: 1px solid #3f72af;
  box-sizing: border-box;
  background-color: #dbe2ef;
  padding: 10px;
  border-radius: 0 0 0 20px;
  color: #000;
}

.main-menu {
  --el-menu-item-height: 25px;
  --el-menu-sub-item-height: calc(var(--el-menu-item-height) - 3px);
}
</style>